import { render, staticRenderFns } from "./payChannelConfig.vue?vue&type=template&id=6a3efd3e&scoped=true"
import script from "./payChannelConfig.vue?vue&type=script&lang=js"
export * from "./payChannelConfig.vue?vue&type=script&lang=js"
import style0 from "./payChannelConfig.vue?vue&type=style&index=0&id=6a3efd3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3efd3e",
  null
  
)

export default component.exports